import React, { useState } from "react";
import TeamMemberList from "../components/TeamMemberList";
import TeamMemberForm from "../components/TeamMemberForm";
import { TeamMember } from "../services/teamMembers";
import "./TeamMembers.css";

const TeamMembers: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingMember, setEditingMember] = useState<TeamMember | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleAddNew = () => {
    setEditingMember(null);
    setShowForm(true);
  };

  const handleEdit = (member: TeamMember) => {
    setEditingMember(member);
    setShowForm(true);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingMember(null);
    setRefreshTrigger((prev) => prev + 1); // Trigger refresh
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingMember(null);
  };

  return (
    <div className="team-members-page">
      <div className="page-header">
        <div>
          <h1>Team Members Management</h1>
          <p>Manage your team members displayed on the About page</p>
        </div>
        {!showForm && (
          <button className="btn btn-add" onClick={handleAddNew}>
            <i className="fas fa-plus"></i> Add New Member
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container">
          <TeamMemberForm
            teamMember={editingMember}
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />
        </div>
      ) : (
        <TeamMemberList onEdit={handleEdit} refreshTrigger={refreshTrigger} />
      )}
    </div>
  );
};

export default TeamMembers;
